import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("4ever_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const authApi = {
  signup: (email, password, name) => api.post("/auth/signup", { email, password, name }),
  login: (email, password) => api.post("/auth/login", { email, password }),
  me: () => api.get("/auth/me"),
  logout: () => api.post("/auth/logout"),
  emergentSession: (session_id) => api.post("/auth/session", { session_id }),
};

export const cartApi = {
  get: () => api.get("/cart"),
  set: (items) => api.put("/cart", items),
};

export const trackerApi = {
  getSettings: () => api.get("/tracker/settings"),
  putSettings: (s) => api.put("/tracker/settings", s),
  getLogs: () => api.get("/tracker/logs"),
  putLog: (log) => api.post("/tracker/logs", log),
  getStreak: () => api.get("/tracker/streak"),
  coach: (payload) => api.post("/tracker/coach", payload),
};

export const communityApi = {
  posts: (circle) => api.get(`/community/posts`, { params: { circle } }),
  create: (circle, text) => api.post("/community/posts", { circle, text }),
  like: (post_id) => api.post(`/community/posts/${post_id}/like`),
  replies: (post_id) => api.get(`/community/posts/${post_id}/replies`),
  reply: (post_id, text) => api.post(`/community/posts/${post_id}/reply`, { text }),
};

export const newsletterApi = {
  subscribe: (email) => api.post("/newsletter", { email }),
};

export const accountApi = {
  get: () => api.get("/account"),
  orders: () => api.get("/orders"),
  order: (id) => api.get(`/orders/${id}`),
  pointsLedger: () => api.get("/points/ledger"),
  getNotifs: () => api.get("/notifications"),
  putNotifs: (p) => api.put("/notifications", p),
  getSub: () => api.get("/subscription"),
  putSub: (p) => api.put("/subscription", p),
  wipeAll: () => api.delete("/privacy/all"),
};

export const checkoutApi = {
  checkout: (items, redeem_points = 0) => api.post("/checkout", { items, redeem_points }),
};
